import PaymentsService from '@/services/paymentsService';

interface CreditCard {
  "cardName": string;
  "cardNumber": string;
  "cardMonth": string;
  "cardYear": string;
  "cardCvv": string;
  "postalCode": string;
  "isFavorite": boolean
}

export const payments = {
  namespaced: true,
  state: {
    creditcards: [] as CreditCard[],
  },
  actions: {
    clear: (context: any) => {
      context.commit('clear');
    },    
    addCreditCardInfo: async (context: any, creditCardInfo: any) => {
      try {
        const success = await PaymentsService.addCreditCardInfo(creditCardInfo);

        return Promise.resolve(success);
      }
      catch (error) {
        return Promise.reject(error);
      }
    },
    getCreditCards({ commit }: any) {
      return PaymentsService.getCreditCards().then((success: any) => {
        commit('setCreditCards', success.data);

        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
    deleteCreditCard({ commit }: any, id: string) {
      return PaymentsService.deleteCreditCard(id)
        .then((success) => {
          return Promise.resolve(success);
        }, error => {
          return Promise.reject(error);
        })
    },
    // updateCreditCardInfo: async (context: any, creditCardInfo: any) => {
    //   try {
    //     const success = await PaymentsService.addCreditCardInfo(creditCardInfo);
    //     return Promise.resolve(success);
    //   }
    //   catch (error) {
    //     return Promise.reject(error);
    //   }
    // },
    getStripeConnectedAccountLink({ commit }: any) {
      return PaymentsService.getStripeConnectedAccountLink().then((success: any) => {
        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
    updateStripeConnectedAccountLink({ commit }: any, data: any) {
      return PaymentsService.updateStripeConnectedAccountLink(data).then((success: any) => {
        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
    creditCardPayment({ commit }: any, data: any) {
      return PaymentsService.creditCardPayment(data).then((success: any) => {
        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
    creditCardPaymentAutomatically({ commit }: any, data: any) {
      return PaymentsService.creditCardPaymentAutomatically(data).then((success: any) => {
        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
    createCheckoutSessionSaveCardDetails({ commit }: any, data: any) {
      return PaymentsService.createCheckoutSessionSaveCardDetails(data).then((success: any) => {
        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
    capture({ commit }: any, data: any) {
      return PaymentsService.capture(data).then((success: any) => {
        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
    cancelPayment({ commit }: any, data: any) {
      return PaymentsService.cancelPayment(data).then(success => {
        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
    getListCustomerPaymentMethods({ commit }: any) {
      return PaymentsService.getListCustomerPaymentMethods().then((success: any) => {
        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
    detachPaymentMethodFromCustomer({ commit }: any, data: any) {
      return PaymentsService.detachPaymentMethodFromCustomer(data).then((success: any) => {
        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
  },
  mutations: {
    clear(state: any) {
      state.creditcards = [] as CreditCard[];
    },
    setCreditCards(state: any, cardsList: CreditCard[]) {
      state.creditcards = cardsList;
    }
  },
  getters: {
    getAllCreditCards: (state: any) => {
      return state.creditcards;
    },
  },
};

export default payments;